import React from 'react'
import 'materialize-css'
import { Card, CardPanel, Row, Col } from 'react-materialize'
import { EsitoResume } from './EsitoResume'
import { EsitoButtons } from './EsitoButtons'

export const EsitoCancel = ({datiRichiesta, idCart}) => {
    return (
        <Card>
            <Row>
                <Col s={12}>
                    <h4>Operazione annullata</h4>
                    <p>I pagamenti per le seguenti pendenze:</p>
                    <EsitoResume datiRichiesta={datiRichiesta} />
                    <p>sono stati annullati.</p>
                </Col>
            </Row>
            <EsitoButtons idCart={idCart} />
        </Card>
    );
}